import React, { FC } from "react";
import Drawer from "shared/components/Drawer";
import { useTagsPage } from "../../context";
import Tabs from "./components/Tabs";
import General from "./components/Tabs/Content/General";
import Translations from "./components/Tabs/Content/Translations";
import { TagDetailsProvider, useTagDetails } from "./context";
import { TagDetailsTabs } from "./context/types";
import TagDetailsSkeleton from "./skeleton";
import ActionButton from "./components/ActionButton";

const TagDetailsContainer: FC = () => (
  <TagDetailsProvider>
    <TagDetails/>
  </TagDetailsProvider>
);

const TagDetails: FC = () => {
  const { tagsDetailsDrawer } = useTagsPage();
  const {
    selectedTab,
    loading,
    onCloseTagDetails,
  } = useTagDetails();

  const title = tagsDetailsDrawer.drawerDetails ? "Edit tag" : "Add new tag";

  const TAB_CONTENT: Record<TagDetailsTabs, FC> = {
    [TagDetailsTabs.General]: General,
    [TagDetailsTabs.Translations]: Translations,
  };
  const ContentComponent = TAB_CONTENT[selectedTab];

  return (
    <Drawer
      title={title}
      isOpen={tagsDetailsDrawer.isOpen}
      onCloseDrawer={onCloseTagDetails}
      headingRight={<ActionButton/>}
      headingBottom={<Tabs/>}
    >
      {loading && <TagDetailsSkeleton />}
      {!loading && <ContentComponent />}
    </Drawer>
  );
};

export default TagDetailsContainer;
